import { formatWithOptions } from 'date-fns/fp'
import ru from 'date-fns/locale/ru'

export const format = formatWithOptions({ locale: ru })

export const normalizePhone = (phone: string): string =>
  phone?.replace(/[ _()-]/g, '')
